export default "__VITE_ASSET__edf7fbc6__"